module.exports = __webpack_public_path__ + "static/media/view fees.65818ed9.svg";